<template>
	<div  id="dashboard-analytics">
        <div  class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  v-if="absencesGained.analyticsData"
                  icon="ListIcon"
                  :statistic="absencesGained.statistics"
                  statisticTitle="Absences Hours"

                  :chartData="absencesGained.series" 
                  
                  type="area" />
            </div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
                  icon="MoonIcon"
                  :statistic="tardinessGained.statistics"
                  statisticTitle="Tardiness Hours"
                  :chartData="tardinessGained.series" 
                  color="success"
                  type="area" />
            </div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
               
                  icon="ClockIcon"
                  :statistic="undertimeGained.statistics"
                  statisticTitle="Undertime Hours"
                  :chartData="undertimeGained.series" 
                  color="danger"
                  type="area" />
            </div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line
               
                  icon="SquareIcon"
                  :statistic="lwopGained.statistics"
                  statisticTitle="Unpaid Leave Hours"
                  :chartData="lwopGained.series" 
                  color="warning"
                  type="area" />
            </div>
        </div>
		<!-- 2nd row -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/3 mb-base">
        <vx-card title="My Schedule" class="no-scroll-content">
          <div slot="no-body" class="mt-4">
            <vs-table :data="getAllScheduleNotClosed" max-items="8" pagination class="table-dark-inverted">
              <template slot="thead">
                <vs-th>DATE</vs-th>
                <vs-th>SHIFT</vs-th>
                <vs-th>IN</vs-th>
                <vs-th>OUT</vs-th>
                <vs-th>TYPE</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].scheduleDate">
                        {{data[indextr].scheduleDate | fulldate}}
                    </vs-td>
                   <vs-td :data="data[indextr].shiftTypeId">
                        {{ shiftTypeName(data[indextr].shiftTypeId).shiftTypeName }}
                    </vs-td>
                    <vs-td :data="data[indextr].scheduleIn">
                        {{ data[indextr].scheduleIn | time }}
                    </vs-td>
                    <vs-td :data="data[indextr].scheduleOut">
                        {{ data[indextr].scheduleOut | time }}
                    </vs-td>
                    <vs-td :data="data[indextr].scheduleTypeId">
                      <span class="flex items-center px-2 py-1 rounded">
                        <div :class="data[indextr].scheduleTypeId == 1 ? 'h-3 w-3 rounded-full mr-2 bg-success' : 
                            data[indextr].scheduleTypeId == 2 ? 'h-3 w-3 rounded-full mr-2 bg-danger' : 
                            data[indextr].scheduleTypeId == 3 ? 'h-3 w-3 rounded-full mr-2 bg-partial' : 'h-3 w-3 rounded-full mr-2 bg-primary'" />
                        {{ scheduleTypeName(data[indextr].scheduleTypeId).scheduleTypeName }}
                      </span>
                    </vs-td>
                </vs-tr>
              </template>
              
            </vs-table>
          </div>

        </vx-card>
      </div>
      <div v-if="getLeaveBenefits" class="vx-col w-full lg:w-1/3 lg:mt-0 mb-base">
                <vx-card title="Leave Balances" >
                    <!-- SLOT = ACTIONS -->
                    <!-- <template slot="actions">
                        <change-time-duration-dropdown />
                    </template> -->
                    
                    <div slot="no-body">
                        <vs-alert color="rgb(231, 154, 23)" :active="leaveBalanceSeries == [0] || leaveBalanceSeries == [] ? true : false" class="mt-5 text-warning" >
                          <span>No Leave Balance</span>
                        </vs-alert>
                        <!-- CHART -->
                        <vue-apex-charts type="pie" height="345" class="mt-10 mb-10" :options="analyticsData.customersPie.chartOptions" :series="leaveBalanceSeries" />

                        <!-- CHART DATA -->
                        <!-- <ul class="mb-1">
                          <li class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">

                          </li>
                            <li :key="index" v-for="(item, index) in getLeaveBenefits" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                                <span class="flex items-center">
                                    <span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-primary`"></span>
                                    <span class="font-semibold">{{ item.leaveTypeName }}</span>
                                </span>
                                <span>{{ checkLeaveBalance(item.leaveTypeId) }}</span>
                            </li>
                        </ul> -->
                    </div>
                    <div class="vx-row">

                    </div>

                </vx-card>
            </div>
      <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base" :key="index" v-for="(item, index) in getLeaveBenefits">
             
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  :icon="item.leaveTypeId == 1 ? 'CoffeeIcon' : 
                        item.leaveTypeId == 2 ? 'ThermometerIcon' : 
                        item.leaveTypeId == 3 ? 'PlusIcon' : 
                        item.leaveTypeId == 4 ? 'ArrowUpRightIcon' :
                        item.leaveTypeId == 5 ? 'SquareIcon' :
                        item.leaveTypeId == 6 ? 'TriangleIcon' :
                        item.leaveTypeId == 7 ? 'CircleIcon' :
                        item.leaveTypeId == 8 ? 'UserIcon' :
                        item.leaveTypeId == 9 ? 'MinusIcon' :'TriangleIcon'"
                  :color="item.leaveTypeId == 1 ? 'success' : 
                        item.leaveTypeId == 2 ? 'danger' : 
                        item.leaveTypeId == 3 ? 'warning' : 
                        item.leaveTypeId == 4 ? 'primary' :
                        item.leaveTypeId == 5 ? 'success' :
                        item.leaveTypeId == 6 ? 'danger' :
                        item.leaveTypeId == 7 ? 'warning' :
                        item.leaveTypeId == 8 ? 'success' :
                        item.leaveTypeId == 9 ? 'danger' :'warning'"
                  :statistic="checkLeaveBalance(item.leaveTypeId)"
                  :statisticTitle="item.leaveTypeName + ' Balance'" />

        </div> -->
    </div>
		<!-- <div class=vx-row>
			<div class="vx-col w-full md:w-3/3">
                <vx-card title="Client Retention" class="mt-base">
					  <vue-apex-charts type="bar" height="350" :options="columnChart.chartOptions" :series="hoursData.series"></vue-apex-charts>
                </vx-card>          
            </div>
		</div> -->
		<!-- 3rd row -->
    <!-- <div class="vx-row"  >
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base" :key="index" v-for="(item, index) in getLeaveBenefits">
             
                <statistics-card-line
                  hideChart
                  class="mb-base"
                  :icon="item.leaveTypeId == 1 ? 'CoffeeIcon' : 
                        item.leaveTypeId == 2 ? 'ThermometerIcon' : 
                        item.leaveTypeId == 3 ? 'PlusIcon' : 
                        item.leaveTypeId == 4 ? 'ArrowUpRightIcon' :
                        item.leaveTypeId == 5 ? 'SquareIcon' :
                        item.leaveTypeId == 6 ? 'TriangleIcon' :
                        item.leaveTypeId == 7 ? 'CircleIcon' :
                        item.leaveTypeId == 8 ? 'UserIcon' :
                        item.leaveTypeId == 9 ? 'MinusIcon' :'TriangleIcon'"
                  :color="item.leaveTypeId == 1 ? 'success' : 
                        item.leaveTypeId == 2 ? 'danger' : 
                        item.leaveTypeId == 3 ? 'warning' : 
                        item.leaveTypeId == 4 ? 'primary' :
                        item.leaveTypeId == 5 ? 'success' :
                        item.leaveTypeId == 6 ? 'danger' :
                        item.leaveTypeId == 7 ? 'warning' :
                        item.leaveTypeId == 8 ? 'success' :
                        item.leaveTypeId == 9 ? 'danger' :'warning'"
                  :statistic="checkLeaveBalance(item.leaveTypeId)"
                  :statisticTitle="item.leaveTypeName + ' Balance'" />

        </div>
    </div> -->

	</div>
</template>
<script>
import moduleLeaveManagement from '@/store/leavemanagement/moduleLeaveManagement.js'
import VueApexCharts from 'vue-apexcharts'
import analyticsData from './ui-elements/card/analyticsData.js'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
export default {
  components: {
    VueApexCharts,
	  StatisticsCardLine,
	},
  created() {
    console.log('DUMAAN')
    if (!this.$store.state.auth.isUserLoggedIn()) 
        this.router.push('/pages/login')
  },
  data() {
    return {
          leaveVacation : {
            name: '',
            balance: 0,
            div: ''
          },
          leaveSick     : {
            name: '',
            balance: 0
          },

          absencesGained: {
                    series: [
                    {
                        name: 'Absences',
                        data: [0]
                    }
                    ],
                    analyticsData: {
                    subscribers: 92600
                    },
                    statistics: 0
                },
          tardinessGained: {
                    series: [
                    {
                        name: 'Tardiness',
                        data: [0]
                    }
                    ],
                    analyticsData: {
                    subscribers: 92600
                    },
                    statistics: 0
                },
          undertimeGained: {
                    series: [
                    {
                        name: 'Undertime',
                        data: [0]
                    }
                    ],
                    analyticsData: {
                    subscribers: 92600
                    },
                    statistics: 0
                },
          lwopGained: {
                    series: [
                    {
                        name: 'Unpaid Leave',
                        data: [0]
                    }
                    ],
                    analyticsData: {
                    subscribers: 92600
                    },
                    statistics: 0
                },
          

          columnChart: {
            
            chartOptions: {
              colors: this.themeColors,
              plotOptions: {
                bar: {
                  horizontal: false,
                  endingShape: 'rounded',
                  columnWidth: '55%',
                },
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
              },

              xaxis: {
                categories: ['Jan','Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              },
              yaxis: {
                title: {
                  text: 'Hours'
                }
              },
              fill: {
                opacity: 1

              },
              tooltip: {
                y: {
                  formatter: function(val) {
                    return  val + " Hours"
                  }
                }
              },

              
            }
        },
        hoursData: {
          series: [{
                name: 'Worked Hours',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
              }, {
                name: 'Overtime',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
              }, {
                name: 'Absences',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }],
        },
        logHoursData: {
          series: [{
              name: 'January',
              hoursWorked: [],
              absences:[],
              tardiness:[],
              undertime:[],
              lwop:[]
            }, {
                name: 'February',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'March',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'April',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'May',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'June',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'July',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'August',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'September',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'October',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'November',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }, {
                name: 'December',
                hoursWorked: [],
                absences:[],
                tardiness:[],
                undertime:[],
                lwop:[]
            }
          ]
        },
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      analyticsData,
      leaveBalanceLabels: [],
      leaveBalanceSeries: [0],
      // test:''
    }
  },
  created() {
    this.$store.registerModule('leavemanagement', moduleLeaveManagement)
    
    const leaves = {
            sortBy: 'CreatedOn',
            sortOrder: 'Desc',
            pageNumber: 1,
            pageSize: -1,
            isApprover: false
        }
    this.$store.dispatch('leavemanagement/getAllLeaves', leaves)
    this.$store.dispatch('lookup/getAllLeaveTypeLookup')
    this.$store.dispatch('lookup/getAllShiftType').catch(err => { console.error(err) })
    this.$store.dispatch('lookup/getAllScheduleType').catch(err => { console.error(err) })
    this.$store.dispatch('hrms/getAllLeaveBenefits', this.$store.state.AppActiveUser.uid)
    this.$store.dispatch('hrms/getAllLeaveBalance', this.$store.state.AppActiveUser.uid)
    this.$store.dispatch('tenants/getAllSettings', this.$store.state.AppActiveUser.tenantsId)
    this.$store.dispatch('timekeeping/getAllScheduleNotClosed', this.$store.state.AppActiveUser.uid)
    this.getLineGraph
    
  },
  beforeDestroy () {
        this.$store.unregisterModule('leavemanagement')
  },
  computed: {
    employeeLeaveBalance() {
      return this.$store.state.hrms.employeeLeaveBalance
    },
    getLeaveBenefits() {
            let eb = []
            let series = []
            let labels = []
            for(var e =0; e < this.$store.state.hrms.employeeLeaveBenefits.length; e++ ) {
                eb.push(this.$store.state.hrms.employeeLeaveBenefits[e].leaveType)
                labels.push(this.$store.state.hrms.employeeLeaveBenefits[e].leaveType.leaveTypeName)
                series.push(Math.abs(this.checkLeaveBalance(this.$store.state.hrms.employeeLeaveBenefits[e].leaveType.leaveTypeId)))
                
                
                // console.log(this.analyticsData.customersPie.chartOptions.labels)
            }
            Object.assign(this.analyticsData.customersPie.chartOptions.labels, labels)
            this.leaveBalanceSeries = series
            return eb
    },
    getEmployeeLeaveRequests() {
      return this.$store.state.leavemanagement.employeeFiledLeaves
    },
    getEmployeeLeaveBalance() {
            return this.$store.state.hrms.employeeLeaveBalance
    },
    getLeaveBalanceByLeaveType() {
      return (leaveTypeId) => {
        this.$store.getters['hrms/employeeLeaveBalanceByLeaveTypeId'](leaveTypeId)
      }
    },
    getAllScheduleNotClosed() {
        return this.$store.state.timekeeping.employeeSchedule
    },
    shiftTypeName() {
        return (shiftTypeId) => this.$store.getters['lookup/shiftTypeLookup'](shiftTypeId)
    },
    scheduleTypeName() {
        return (scheduleTypeId) => this.$store.getters['lookup/scheduleTypeLookup'](scheduleTypeId)
    },
    leaveType() {
             return (leaveTypeId) => this.$store.getters['lookup/leaveTypeLookup'](leaveTypeId)
        },
    onGetStatus() {
        return (data) => {
          var leaveStatus = ''
          var c = data.approversLMs.length
          data.approversLMs.forEach((a) => {
              if(a.isApproved && a.priorityId == 1){
                  if(c > 1) {
                      leaveStatus = 'Partially Approved'
                  }
                  else
                      leaveStatus = 'Approved'
              } else if(a.isApproved && a.priorityId == 2){
                  if(c > 2) {
                      leaveStatus = 'Partially Approved'
                  }
                  else
                      leaveStatus = 'Approved'
              }else if (data.isCancelled) {
                  leaveStatus = 'Cancelled'
              } else if(a.isRevised) { 
                  leaveStatus = 'For Revision'
              }else if(data.isRetracted) { 
                  leaveStatus = 'Retracted'
              }else if(a.isDenied) { 
                  leaveStatus = 'Denied'
              }else if (data.isDraft) {
                  leaveStatus = 'Draft'
              }else if (data.isSubmitted && leaveStatus == '') {
                  leaveStatus = 'Pending'
              }
          })
          return leaveStatus
        }
        },
    checkLeaveBalance() {
        return (leaveTypeId) => {
            var lt = this.leaveType(leaveTypeId)
            let leaveRequest = this.getEmployeeLeaveRequests
            var leavesTaken = 0

            leaveRequest.forEach(l => {
                if(l.leaveTypeId == leaveTypeId) {
                    if(this.onGetStatus(l) != 'Cancelled' && 
                    this.onGetStatus(l) != 'Retracted' &&
                    this.onGetStatus(l) != 'Denied')
                        leavesTaken += l.noOfDays
                }
            })
            let leavesBalance = this.getEmployeeLeaveBalance
            var leavesCredited = 0

            leavesBalance.forEach(l => {
                // if(l.leaveTypeId == leaveTypeId && leavesCredited <= lt.maxDays)
                if(l.leaveTypeId == leaveTypeId)
                    leavesCredited += l.leaveDays
            })
            if(leavesCredited > lt.maxDays)
              leavesCredited = leavesCredited - (leavesCredited - lt.maxDays)
            // this.leaveBalanceObjects.push(leavesCredited - leavesTaken)
            // console.log(this.leaveBalanceObjects)
            // this.leaveBalanceSeries = Object.entries(this.leaveBalanceObject)
            return leavesCredited - leavesTaken 
        }
           
      },
      getLineGraph() {
      this.$http.get('/api/payroll/employeeloghourshistory')
        .then((response) => {
        let dt =  response.data.data
        var logHours = []
        var logHoursSum = 0
        let absences = []
        let absencesSum = 0
        let tardiness = []
        let tardinessSum = 0
        let undertime = []
        let undertimeSum = 0
        let lwop = []
        let lwopSum = 0

          dt.forEach(d => {
            logHours.push(d.hoursWorked == 0 ? 8 : d.hoursWorked)
            absences.push(d.absencesHours)
            tardiness.push(d.tardinessHours)
            undertime.push(d.undertimeHours)
            lwop.push(d.lwopHours)
            

            logHoursSum += d.hoursWorked == 0 ? 8 : d.hoursWorked 
            absencesSum += d.absencesHours 
            tardinessSum += d.tardinessHours 
            undertimeSum += d.undertimeHours            
            lwopSum += d.lwopHours

            // switch (d.createPayroll.monthName) {
            //   case 1:
            //       logHoursSum += d.hoursWorked == 0 ? 8 : d.hoursWorked
            //       absencesSum += d.absencesHours 
            //       tardinessSum += d.tardinessHours 
            //       undertimeSum += d.undertimeHours            
            //       lwopSum += d.lwopHours
            //       break;
            // }
            // Object.assign(this.lwopGained.series[0], { hoursWorked: logHoursSum, absences: absencesSum, tardiness: tardinessSum, undertime: undertimeSum, lwop: lwopSum })
          })
          console.log('absences')
            console.log(tardiness)
           Object.assign(this.absencesGained.series[0], { data : absences })
          //  Object.assign(this.tardinessGained.series[0], { data: tardiness })
          this.tardinessGained.series[0].data = tardiness
          console.log(this.tardinessGained.series[0].data )
           Object.assign(this.undertimeGained.series[0], { data: undertime })
           Object.assign(this.lwopGained.series[0], { data: lwop })
           this.absencesGained.statistics = absencesSum
          //  this.$alert('',this.absencesGained.statistics,'success')
            
           this.tardinessGained.statistics = tardinessSum
            
           this.undertimeGained.statistics = undertimeSum
           
           this.lwopGained.statistics = lwopSum

          return true
        })
    },
  },
  methods: {
    
    
  }
            
}
</script>
<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
